/**
 * Centralized Axios Instance with Cookie-Based JWT Authentication
 * 
 * Cookie-Based Authentication:
 * - JWT tokens stored in HttpOnly cookies (backend-managed)
 * - Browser automatically sends cookies with every request
 * - withCredentials: true ensures cookies are sent
 * - 401 responses trigger automatic redirect to login
 */

import axios from "axios";
import _config from "../../config";

const axiosInstance = axios.create({
  baseURL: _config.BASE_URL,
  withCredentials: true,
});

// Request interceptor - minimal config needed for cookie-based auth
axiosInstance.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);

// Response interceptor - handle authentication errors
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      try {
        const SSO = (await import("../../sso/index")).default;
        SSO.redirectToSignInUrl();
      } catch (importError) {
        console.error('Failed to redirect to login:', importError);
        window.location.href = '/preLogin';
      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
